module.exports = __webpack_public_path__ + "static/media/tachometer-alt-slowest.b242891f.svg";